/**
 * One-click sample images.
 *
 * This is the single biggest usability win on the landing page: without it a
 * visitor must go and find a file before anything happens, which is where most
 * people leave. With it, the product demonstrates itself in one click.
 *
 * The shipped files are synthetic placeholders generated by
 * scripts/make-samples.mjs. Replace them with real photos before launch --
 * see README. Keep them in public/samples/ so they are same-origin (the app
 * sets COEP: require-corp, which blocks un-opted-in cross-origin images).
 */
export const SAMPLES = [
    { id: 'mug', src: '/bg-remover/samples/mug.png', label: 'Product' },
    { id: 'plant', src: '/bg-remover/samples/plant.png', label: 'Plant' },
    { id: 'headphones', src: '/bg-remover/samples/headphones.png', label: 'Gadget' },
];
/** Fetch a sample and hand it back as a File, so it joins the normal flow. */
export async function loadSample(sample) {
    const res = await fetch(sample.src);
    if (!res.ok)
        throw new Error(`Could not load the ${sample.label} sample`);
    const blob = await res.blob();
    return new File([blob], `${sample.id}.png`, { type: blob.type || 'image/png' });
}
